import { ValuesByDimension } from '../lineGraph.types';

export const getDimensionData = ({
	periodDatesInRange,
	dimensionKey,
	valuesByDimension,
}: {
	periodDatesInRange: Array<Date>;
	dimensionKey: string;
	valuesByDimension: ValuesByDimension;
}) => {
	const dimensionData = periodDatesInRange.map((periodDate) => {
		const value = valuesByDimension[dimensionKey][periodDate.toString()];

		return {
			x: periodDate,
			y: value ?? null,
		};
	});

	const filteredDimensionData = dimensionData.filter(({ y }) => y != null);

	return {
		dimensionData,
		filteredDimensionData,
	};
};
